import * as React from 'react';
import { configure } from 'mobx';
import { ThemeProvider, JssProvider } from 'react-jss';

import { canUseDOM } from 'sletat-common-utils/lib/canUseDOM';

import { HotelPage } from './components/HotelPage';
import { ErrorInterceptor } from './components/ErrorInterceptor';
import { defaultTheme } from './theme';
import { logVersion } from '../utils/logger';
import { pushToDataLayerOnInitForHotelPage } from '../utils/google-tag-manager';
import { createGenerateClassName } from './utils/jss';
import { init as initSentry } from '../utils/sentry';


const generateClassName = createGenerateClassName({
    dangerouslyUseGlobalCSS: false,
    productionPrefix: 'HotelPage',
    seed: '3' // идентификатор для development сборки, который будет подмешиваться в className элементов
});


export function App() {
    return (
        <ThemeProvider theme={defaultTheme}>
            <JssProvider generateClassName={generateClassName}>
                <ErrorInterceptor>
                    <div id="__portal" />
                    <HotelPage />
                </ErrorInterceptor>
            </JssProvider>
        </ThemeProvider>
    );
}


if (canUseDOM) {
    configure({
        enforceActions: process.env.NODE_ENV !== 'development',
        isolateGlobalState: true
    });

    initSentry();
    pushToDataLayerOnInitForHotelPage();
    logVersion(__PROJECT_NAME__, __BUILD_VERSION__, process.env.NODE_ENV!);

    // window?.__SLETAT_ACTIONS__.auth.addChangeListener(() => renderApp());
}
